/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtSummary } from './CourtSummary';
import {
    CourtSummaryFromJSON,
    CourtSummaryFromJSONTyped,
    CourtSummaryToJSON,
    CourtSummaryToJSONTyped,
} from './CourtSummary';
import type { CategorySummary } from './CategorySummary';
import {
    CategorySummaryFromJSON,
    CategorySummaryFromJSONTyped,
    CategorySummaryToJSON,
    CategorySummaryToJSONTyped,
} from './CategorySummary';
import type { MatchSummary } from './MatchSummary';
import {
    MatchSummaryFromJSON,
    MatchSummaryFromJSONTyped,
    MatchSummaryToJSON,
    MatchSummaryToJSONTyped,
} from './MatchSummary';

/**
 * 
 * @export
 * @interface MatchesListResponse
 */
export interface MatchesListResponse {
    /**
     * 
     * @type {Array<MatchSummary>}
     * @memberof MatchesListResponse
     */
    matches?: Array<MatchSummary>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatchesListResponse
     */
    dates?: Array<string>;
    /**
     * 
     * @type {Array<CourtSummary>}
     * @memberof MatchesListResponse
     */
    courts?: Array<CourtSummary>;
    /**
     * 
     * @type {Array<CategorySummary>}
     * @memberof MatchesListResponse
     */
    categories?: Array<CategorySummary>;
}

/**
 * Check if a given object implements the MatchesListResponse interface.
 */
export function instanceOfMatchesListResponse(value: object): value is MatchesListResponse {
    return true;
}

export function MatchesListResponseFromJSON(json: any): MatchesListResponse {
    return MatchesListResponseFromJSONTyped(json, false);
}

export function MatchesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchesListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(MatchSummaryFromJSON)),
        'dates': json['dates'] == null ? undefined : json['dates'],
        'courts': json['courts'] == null ? undefined : ((json['courts'] as Array<any>).map(CourtSummaryFromJSON)),
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(CategorySummaryFromJSON)),
    };
}

export function MatchesListResponseToJSON(json: any): MatchesListResponse {
    return MatchesListResponseToJSONTyped(json, false);
}

export function MatchesListResponseToJSONTyped(value?: MatchesListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(MatchSummaryToJSON)),
        'dates': value['dates'],
        'courts': value['courts'] == null ? undefined : ((value['courts'] as Array<any>).map(CourtSummaryToJSON)),
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(CategorySummaryToJSON)),
    };
}

